module.exports = __webpack_public_path__ + "media/components/country-flag/static/un-ec7069b6dc9e13e0ffe1e7dc53ff8cb9.svg";